import React, { useEffect, useState } from "react";
import Sidebar from "../../SideBar";
import { Row, Col, Label, Input, Button } from "reactstrap";
import { MdAttachFile } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { IoIosSave } from "react-icons/io";
import {
  createOrUpdateMessageSetting,
  listMessageSetting,
  updateMessageSettingStatus,
} from "../../../components/Header/Data3";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import uploadToS3 from "../../../utils/awsS3Upload";

const AutoScheduleMessages = () => {
  const userinfo = useSelector((state) => state.user.userInfo);
  const islogin = useSelector((state) => state.user.isLogin);
  const user = islogin ? JSON.parse(userinfo) : null;
  const isAdmin = user && user.Role === "admin";
  const [filePreviews, setFilePreviews] = useState({});
  const [filesToUpload, setFilesToUpload] = useState({});

  const [messages, setMessages] = useState([
    {
      Id: 1,
      count: "initial Message",
      delay: 1,
      content: "",
      file: null,
    },
  ]);

  const maxMessagesAllowed = isAdmin ? 10 : 4;

  const fetchlistMessageSetting = async () => {
    const Id = user?.UserID;

    const response = await listMessageSetting(Id);
    console.log(response, "fetchlistMessageSetting");
    const filterSaved = response.filter(
      (item) =>
        item.messageSettingStatus === 0 || item.messageSettingStatus === 1
    );
    console.log(filterSaved, "fetchlistMessageSetting");
    if (Array.isArray(filterSaved) && filterSaved.length > 0) {
      // Sort by messageType or createdAt to ensure consistent order
      const sortedMessages = [...filterSaved].sort((a, b) => a.Id - b.Id);
      const mappedMessages = sortedMessages.map((item, index) => ({
        Id: item.Id,
        count:
          index === 0
            ? "initial message"
            : `${index + 1}${getOrdinalSuffix(index + 1)} message`,
        delay: item.hourDelay || 1,
        content: item.messageContent || "",
        file: item.messageImage || null, // You may want to fetch or convert image later
        messageSettingStatus: item.messageSettingStatus,
      }));

      const filePreviews = {};
      mappedMessages.forEach((message) => {
        if (message.file) {
          filePreviews[message.Id] = message.file;
        }
      });
      setFilePreviews(filePreviews);
      // Add a blank row at the end
      const totalMessages = mappedMessages.length;
      if (totalMessages < maxMessagesAllowed) {
        const newId = totalMessages + 1;
        const blankMessage = {
          Id: newId,
          count: `${newId}${getOrdinalSuffix(newId)} message`,
          delay: 1,
          content: "",
          file: null,
          messageSettingStatus: null, // indicates it's unsaved
        };
        console.log(mappedMessages, "mappedMessages");
        console.log([...mappedMessages, blankMessage], "blankMessage");
        setMessages([...mappedMessages, blankMessage]);
      } else {
        // fallback to one initial blank message
        setMessages(mappedMessages);
      }
    }
  };
  console.log(filePreviews, "filePreviews");
  useEffect(() => {
    fetchlistMessageSetting();
  }, []);
  const handleAddMessage = () => {
    const newId = messages.length + 1;
    const newMessage = {
      Id: newId,
      count: `${newId}${getOrdinalSuffix(newId)} message`,
      delay: 1,
      content: "",
      file: null,
    };

    // Correct: only one state update
    setMessages((prevMessages) => [...prevMessages, newMessage]);
  };

  const getOrdinalSuffix = (n) => {
    if (n === 1) return "st";
    if (n === 2) return "nd";
    if (n === 3) return "rd";
    return "th";
  };
  const handleSaveMessage = async (Id) => {
    const messageToSave = messages.find((msg) => msg.Id === Id);
    if (!messageToSave) return;

    // ✅ Validate: message content must not be empty
    if (!messageToSave.content || messageToSave.content.trim() === "") {
      toast.error("Please add Message Content");
      return;
    }

    let uploadedImageUrl = null;

    const fileToUpload = filesToUpload[Id];

    if (fileToUpload) {
      try {
        uploadedImageUrl = await uploadToS3(fileToUpload, "auto-messages/");

        // Optionally update preview with final URL
        setFilePreviews((prev) => ({
          ...prev,
          [Id]: uploadedImageUrl,
        }));

        // Clear fileToUpload if you want (optional)
        setFilesToUpload((prev) => {
          const newState = { ...prev };
          delete newState[Id];
          return newState;
        });
      } catch (err) {
        toast.error("Upload failed");
        return;
      }
    } else {
      uploadedImageUrl = messageToSave.file;
    }

    // Upload to S3 if there's a file (only File objects, not URLs)
    // if (messageToSave.file && messageToSave.file instanceof File) {
    //   const folder = "auto-messages/";
    //   try {
    //     uploadedImageUrl = await uploadToS3(messageToSave.file, folder);
    //   } catch (error) {
    //     console.error("Error uploading to S3:", error);
    //     toast.error("Image upload failed.");
    //     return;
    //   }
    // } else if (typeof messageToSave.file === "string") {
    //   // Already a URL from backend
    //   uploadedImageUrl = messageToSave.file;
    // }

    const formData = {
      vendorId: user?.UserID,
      messageType: Id,
      hourDelay: parseInt(messageToSave.delay),
      messageContent: messageToSave.content,
      createdBy: user?.UserID,
      messageSettingStatus: isAdmin ? 1 : 0,
      isAdmin: isAdmin ? 1 : 0,
      messageImage: uploadedImageUrl, // You may need to convert to base64 or FormData if it's a file
    };

    console.log(formData, "handleSaveMessage");

    await createOrUpdateMessageSetting(formData);
    if (!isAdmin) {
      toast.success("Sent for Admin Approval");
    } else {
      toast.success("Message Added Successfully");
    }

    const updatedMessages = messages.map((msg) =>
      msg.Id === Id ? { ...msg, messageSettingStatus: isAdmin ? 1 : 0 } : msg
    );

    let finalMessages = [...updatedMessages];

    const currentCount = finalMessages.filter(
      (m) => m.messageSettingStatus !== null
    ).length;

    const hasBlank = finalMessages.some((m) => m.messageSettingStatus === null);

    // Add a blank message if we haven't reached the limit and none exists
    if (currentCount < maxMessagesAllowed && !hasBlank) {
      const newId = finalMessages.length + 1;
      const blankMessage = {
        Id: newId,
        count: `${newId}${getOrdinalSuffix(newId)} message`,
        delay: 1,
        content: "",
        file: null,
        messageSettingStatus: null,
      };
      finalMessages.push(blankMessage);
    }

    setMessages(finalMessages);
    fetchlistMessageSetting();
  };

  const handleDeleteMessage = async (Id) => {
    if (messages.length === 1) return;

    const formData = {
      Id: Id, // lowercase unless your API needs 'Id'
      messageSettingStatus: 2,
    };

    try {
      await updateMessageSettingStatus(formData);

      const filteredMessages = messages.filter((message) => message.Id !== Id);

      // Re-assign counts and IDs
      const updatedMessages = filteredMessages.map((msg, index) => ({
        ...msg,
        Id: index + 1,
        count:
          index === 0
            ? "initial message"
            : `${index + 1}${getOrdinalSuffix(index + 1)} message`,
      }));

      const hasBlank = updatedMessages.some(
        (m) => m.messageSettingStatus === null
      );

      // Add a new blank message if we're below limit and no blank exists
      if (updatedMessages.length < maxMessagesAllowed && !hasBlank) {
        const newId = updatedMessages.length + 1;
        const blankMessage = {
          Id: newId,
          count: `${newId}${getOrdinalSuffix(newId)} message`,
          delay: 1,
          content: "",
          file: null,
          messageSettingStatus: null,
        };
        setMessages([...updatedMessages, blankMessage]);
      } else {
        setMessages(updatedMessages);
      }
      toast.success("Message deleted.");
    } catch (error) {
      console.error("Failed to update message status", error);
      // Optionally show user feedback here
    }
    fetchlistMessageSetting();
  };

  const handleFileChange = (event, Id) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const previewUrl = reader.result;

      // Update file in messages
      const updatedMessages = messages.map((message) =>
        message.Id === Id ? { ...message, file } : message
      );
      setMessages(updatedMessages);

      // Set the preview (base64)
      setFilePreviews((prev) => ({
        ...prev,
        [Id]: previewUrl,
      }));

      // Store file for later upload
      setFilesToUpload((prev) => ({
        ...prev,
        [Id]: file,
      }));

      // Update preview URL (base64)
      // setFilePreviews((prev) => ({
      //   ...prev,
      //   [id]: previewUrl,
      // }));
    };

    reader.readAsDataURL(file); // reads as base64
  };

  const isValidImage = (src) =>
    typeof src === "string" &&
    (src.startsWith("data:image") || src.startsWith("http"));

  console.log(filePreviews, "filePreviews");

  const handleContentChange = (event, Id) => {
    const content = event.target.value;
    const updatedMessages = messages.map((message) => {
      if (message.Id === Id) {
        return { ...message, content: content };
      }
      return message;
    });
    setMessages(updatedMessages);
  };
  const handleDelayChange = (event, Id) => {
    const delay = event.target.value;
    const updatedMessages = messages.map((message) => {
      if (message.Id === Id) {
        return { ...message, delay: delay };
      }
      return message;
    });
    setMessages(updatedMessages);
  };

  return (
    <section className="home-after-login bg-white position-relative">
      <div className="container ">
        <Row className="">
          <Col sm={3}>
            <Sidebar />
          </Col>
          <Col sm={9}>
            <div style={{ textAlign: "justify" }}>
              <h3>Auto Schedule Messages</h3>
              <p className="text-dark">
                We understand your time is busy so we developed this service to
                allow Follow up messages to be Auto sent to leads. This means
                once you get your lead, you don't have to worry about engaging
                via email or text message because the system will auto do it for
                you. All you need to do is write within the "message content"
                what you would like sent to the newly acquired lead & you may
                attach an image if you wish. The initial follow up message hour
                delay is based upon the trigger event - which is Admin Approval
                of your request for the customer.
              </p>
              <p className="text-dark">
                Once the customer replies, the remaining scheduled messages are
                auto halted, so that you can personally reply to the customer.
                We recommend you call the lead via "Group Call" once the 4th
                message is sent out and you still have not seen any reply from
                the customer.
              </p>
            </div>
            <div style={{ fontSize: "14px" }}>
              <Row className="text-center d-lg-flex d-none">
                <Col lg={6}>
                  <Row>
                    <Col lg={6}>
                      <Label className="mb-3">Count of follow up msg</Label>
                    </Col>
                    <Col lg={6}>
                      <Label className="mb-3">Sent at</Label>
                    </Col>
                  </Row>
                </Col>
                <Col lg={4}>
                  <Row>
                    <Col lg={7}>
                      <Label className="mb-3">
                        Message Content<b className="text-danger">*</b>
                      </Label>
                    </Col>
                    <Col lg={5}>
                      <Label className="mb-3">Attach Image</Label>
                    </Col>
                  </Row>
                </Col>
                <Col lg={2}>
                  <div className="mb-3">Action Buttons</div>
                </Col>
              </Row>
              {messages.map((message, index) => (
                <Row key={message.Id} className="text-center mb-3">
                  <Col lg={6}>
                    <Row>
                      <Col lg={6}>
                        <Label className="mb-3 d-block d-lg-none">
                          Count of follow up msg
                        </Label>
                        <div>{message.count}</div>
                      </Col>
                      <Col lg={6}>
                        <Label className="mb-3 d-block d-lg-none">
                          Sent at
                        </Label>
                        <div>
                          <select
                            id="delay"
                            name="delay"
                            value={message.delay}
                            onChange={(event) =>
                              handleDelayChange(event, message.Id)
                            }
                            disabled={message.messageSettingStatus === 0}
                          >
                            {Array.from({ length: 10 }, (_, i) => i + 1).map(
                              (num) => (
                                <option key={num} value={num}>
                                  {num}
                                </option>
                              )
                            )}
                          </select>
                          <span className="ms-2">
                            {messages.length === 1 || index === 0
                              ? "hour delay (recommend)"
                              : "hour delay from previous msg (recommend)"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={4}>
                    <Row>
                      <Col lg={7}>
                        <Label className="mb-3 d-block d-lg-none">
                          Message Content
                        </Label>
                        <Input
                          type="textarea"
                          value={message.content}
                          onChange={(event) =>
                            handleContentChange(event, message.Id)
                          }
                          disabled={message.messageSettingStatus === 0}
                        />
                      </Col>
                      <Col
                        lg={5}
                        className="d-flex align-items-center justify-content-center"
                      >
                        <Label className="mb-3 d-block d-lg-none">
                          Attach Image
                        </Label>
                        <div
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            message.messageSettingStatus !== 0 &&
                            document
                              .getElementById(`fileInput-${message.Id}`)
                              .click()
                          }
                        >
                          <input
                            type="file"
                            id={`fileInput-${message.Id}`}
                            accept="image/*,image/heic"
                            style={{
                              display: "none",
                            }}
                            onChange={(event) =>
                              handleFileChange(event, message.Id)
                            }
                          />
                          {filePreviews[message.Id] ? (
                            <img
                              src={filePreviews[message.Id]}
                              alt="preview"
                              style={{
                                width: "100px",
                                height: "60px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          ) : (
                            <span
                              style={{
                                color: "blue",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <MdAttachFile size={30} />
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    lg={2}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <div className="mb-3 d-block d-lg-none">Action Buttons</div>
                    <Row>
                      <Col lg={messages.length > 1 ? 6 : 12}>
                        <Label>{"     "}</Label>
                        <Button
                          onClick={() => handleSaveMessage(message.Id)}
                          color="success"
                          disabled={message.messageSettingStatus === 0}
                        >
                          Save
                        </Button>
                      </Col>

                      {/* Only show delete button if it's not the last message */}
                      {messages.length > 1 && (
                        <Col lg={6}>
                          <Label>{"     "}</Label>
                          <Button
                            onClick={() => handleDeleteMessage(message.Id)}
                            color="danger"
                          >
                            Delete
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </Col>

                  {/* <Col lg={6}>
                        <Label>{"     "}</Label>
                        <Button onClick={() => handleDeleteMessage(message.id)}>
                          {message.id === 1 ? <IoIosSave /> : <MdDelete />}
                        </Button>
                      </Col>
                      {message.id > 1 && (
                        <Col lg={6}>
                          <Label>{"     "}</Label>
                          <Button>
                            <MdDelete />
                          </Button>
                        </Col>
                      )} */}
                </Row>
              ))}
              {/* <div className="text-end mt-3">
                <Button onClick={handleAddMessage}>Add another message</Button>
              </div> */}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default AutoScheduleMessages;
